<pw-view-title *ngIf="ms$ | async as ms">
  {{ ms.TEXT }}
</pw-view-title>

<div class="p4m-grid-2-col">
  <mat-card *ngIf="ms$ | async as ms">
    <mat-card-header>
      <mat-card-title
        >{{ 'general.infoPanels.ms.title' | translate }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div
        style="display: grid; grid-template-columns: auto 1fr; grid-gap: 8px">
        <div style="font-weight: bold">Name</div>
        <div>{{ ms.NAME }}</div>

        <div style="font-weight: bold">
          {{ 'general.infoPanels.ms.description' | translate }}
        </div>
        <div>{{ ms.DESCRIPTION }}</div>

        <div style="font-weight: bold">
          {{ 'general.infoPanels.ms.type' | translate }}
        </div>
        <div>{{ ms.TYP_NAME }}</div>

        <div style="font-weight: bold">
          {{ 'general.infoPanels.ms.kind' | translate }}
        </div>
        <div>{{ ms.ART_NAME }}</div>

        <div style="font-weight: bold">
          {{ 'general.infoPanels.ms.targetDeadline' | translate }}
        </div>
        <div>{{ ms.MS_DATUM | date }}</div>

        <div style="font-weight: bold">
          {{ 'general.infoPanels.ms.actualDeadline' | translate }}
        </div>
        <div>{{ ms.MS_DATUM_FERTIG | date }}</div>

        <div style="font-weight: bold">
          {{ 'general.infoPanels.ms.initialDeadline' | translate }}
        </div>
        <div>{{ ms.INITIAL_DATE | date }}</div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="ms$ | async as ms">
    <mat-card-header>
      <mat-card-title>Status</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div style="display: grid; grid-template-columns: auto 1fr">
        <div style="font-weight: bold">
          {{ 'general.infoPanels.ms.finished' | translate }}
        </div>
        <mat-checkbox disabled [checked]="ms.ISTBEARBEITET"></mat-checkbox>

        <div style="font-weight: bold">
          {{ 'general.infoPanels.ms.planned' | translate }}
        </div>
        <mat-checkbox disabled [checked]="ms.ISTGEPLANT"></mat-checkbox>

        <div style="font-weight: bold">
          {{ 'general.infoPanels.ms.fixed' | translate }}
        </div>
        <mat-checkbox disabled [checked]="ms.ISTFIXIERT"></mat-checkbox>

        <div style="font-weight: bold">
          {{ 'general.infoPanels.ms.partiallyDischarged' | translate }}
        </div>
        <mat-checkbox disabled [checked]="ms.ISTTEILENTLASTET"></mat-checkbox>

        <div style="font-weight: bold">
          {{ 'general.infoPanels.ms.discharged' | translate }}
        </div>
        <mat-checkbox disabled [checked]="ms.ISTENTLASTET"></mat-checkbox>
      </div>
    </mat-card-content>
  </mat-card>
</div>
